import React from 'react';

const ErrorBanner = ({ children }) => {
	if (!children) return null;

	return (
		<div className="w-full rounded-[10px] bg-[#fdecec] px-[14px] py-[10px] text-[13px] text-[#b42318]">{children}</div>
	);
};

export default ErrorBanner;
